import React from 'react'
// libs
import styled, { css } from 'styled-components'
// themes
import { colors } from 'themes'
import { FilterIconWrapper, SearchWrapper as SearchWrapperOrigin } from 'themes/views/layouts'
import ArrowDropDownIconOrigin from '@mui/icons-material/FilterListOutlined'
import SearchRoundedIconOrigin from '@mui/icons-material/SearchRounded'
// utils
import { size } from 'polished'

const Form = styled('form')<{ $isFocused: boolean }>`
  width: ${({ $isFocused }) => ($isFocused ? '460px' : '160px')};
  transition: all 0.2s ease;
`

const SearchWrapper = styled(SearchWrapperOrigin)`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  border-radius: 25px;
  width: inherit;
  background-color: ${colors.darkBlue400};

  div:nth-child(2) {
    margin: 0 45px;
  }
`

const ArrowDropDownIcon = styled((props) => <ArrowDropDownIconOrigin {...props} />)`
  && {
    cursor: pointer;
    ${size('30px')};
  }
`

const SearchRoundedIcon = styled((props) => <SearchRoundedIconOrigin {...props} />)`
  && {
    ${size('30px')};
  }
`

const ActiveFilterIconWrapper = styled(FilterIconWrapper)<{ $isActive: boolean }>`
  ${({ $isActive }) =>
    $isActive &&
    css`
      right: 3px;
      background: ${colors.white};
      height: 34px;
      width: 34px;
      margin-top: 3px;
      border-radius: 50%;

      svg {
        path {
          fill: ${colors.purple400};
        }
      }
    `}
`

export { ActiveFilterIconWrapper, Form, SearchWrapper, ArrowDropDownIcon, SearchRoundedIcon }
